export default __webpack_public_path__ + "static/media/cover_big.749f2b5b.jpg";